import React from "react";
import PropTypes from 'prop-types';
import { NavLink } from "react-router-dom";

export default class InternalLink extends React.PureComponent {
    render() {
        let { link, text, className, children } = this.props;

        return (
            <NavLink to={link} className={className}>
                {text}{children}
            </NavLink>
        );
    }
}

InternalLink.propTypes = {
    text: PropTypes.string,
    link: PropTypes.string.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
};
